import React from 'react';
import AudioPlayer from '../partials/AudioPlayer';
import { SlideProps } from '../SlideHandler';
import {
	TourLine,
	VTInnerImg,
	VTInnerImgContainer,
	VTSlideDescription,
	VTSlideInner,
	VTSlideTitle,
	VTTrailTitle,
} from '../virtualTourStyles';
import { BackgroundTest2 } from '../../../Global/Icons/Icons';
import { checkImage, checkMedia, checkString } from '../../../componentUtils';
import { BGTest } from '../../../Global/styles';
import parse from 'html-react-parser';

const AudioSlide: React.FC<SlideProps> = ({
	point,
	title,
	setSheetOpen,
	setDescription,
}) => {
	const handleDescription = () => {
		if (point.description) {
			setSheetOpen(true);
			setDescription(parse(checkString(point.description)));
		}
	};
	return (
		<>
			<VTSlideInner>
				<BGTest>
					<BackgroundTest2 />
				</BGTest>
				{title && <VTTrailTitle>{title}</VTTrailTitle>}
				<VTSlideTitle>{point.title}</VTSlideTitle>
				<VTInnerImgContainer>
					<VTInnerImg src={checkImage(point.poi_image)} />
				</VTInnerImgContainer>
				<AudioPlayer src={checkMedia(point.poi_audio)} />

				<VTSlideDescription onClick={() => handleDescription()}>
					<div>{point.short_description}</div>
				</VTSlideDescription>
			</VTSlideInner>
			<TourLine />
		</>
	);
};

export default AudioSlide;
